import { render, staticRenderFns } from "./PatientSamplesTab.vue?vue&type=template&id=80479ace&"
import script from "./PatientSamplesTab.vue?vue&type=script&lang=js&"
export * from "./PatientSamplesTab.vue?vue&type=script&lang=js&"
import style0 from "./PatientSamplesTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports